import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import Progressbar from "@badrap/bar-of-progress";
import store from "store";
import { isTokenExist } from "utils/cookies";
import { logout } from "appredux/configSlice";
import {
  loadingInitSelector,
  loadedInitSelector,
  crmIsoReadySelector, // [crm-iso]
  // selectedCompanySelector,
} from "appredux/selectors";
// import Footer from "./Footer";
import MainLayout from "./MainLayout";
import useLoadInits from "hooks/useLoadInits";
import useLoadCrmIsoSetting from "hooks/useLoadCrmIsoSetting"; // [crm-iso]
import useSyncConversationType from "hooks/useSyncConversationType";
import PageLoader from "components/UI/PageLoader";

const progress = new Progressbar({
  size: 4,
  color: "#46be8a",
  className: "z-40",
  delay: 100,
});

const Main = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const loadingInit = useSelector(loadingInitSelector);
  const loadedInit = useSelector(loadedInitSelector);
  const crmIsoReady = useSelector(crmIsoReadySelector); // [crm-iso]
  // const selectedCompany = useSelector(selectedCompanySelector);
  const tokenExist = isTokenExist();
  // Sudah login tapi belum pilih perusahaan (terakhir di halaman pilih
  // perusahaan, lalu buka domain/tab baru) → kembalikan ke sana. Inits di sini
  // WAJIB tidak jalan: tanpa app.endpoint inits ke base URL awal 404 dan
  // jalur 404 me-logout user sebelum redirect sempat sampai.
  const needSelectCompany =
    tokenExist &&
    !store.get("app.endpoint") &&
    !!store.get("app.bootstrapEndpoint");

  // skipCheckEndpoint=false saat needSelectCompany → gate app.endpoint menahan inits
  useLoadInits(!needSelectCompany);
  useLoadCrmIsoSetting(); // [crm-iso]
  useSyncConversationType();

  useEffect(() => {
    if (!tokenExist) {
      store.set("app.previousPathname", location.pathname);
      dispatch(logout());
      navigate("/user/login", { replace: true, state: { from: location } });
    } else if (needSelectCompany) {
      navigate("/user/select-company", { replace: true });
    }
  }, [dispatch, location, navigate, tokenExist, needSelectCompany]);

  useEffect(() => {
    if (loadingInit) {
      progress.start();
    } else {
      progress.finish();
    }
  }, [loadingInit]);

  // if (!tokenExist || !selectedCompany?.website_id) {
  //   return null;
  // }

  // Selama data inits belum termuat (setelah login / saat refresh dalam keadaan
  // login), tampilkan loader bermerek alih-alih merender app dengan data kosong.
  // needSelectCompany: loadedInit bisa sudah true (login multi company), jangan
  // render app tanpa perusahaan selama menunggu redirect.
  // [crm-iso] Tahan juga sampai crm_iso ready → inits & crm_iso harus sama-sama
  // siap sebelum app dirender. TEARDOWN: kembalikan `!(loadedInit && crmIsoReady)` → `!loadedInit`.
  if ((tokenExist && !(loadedInit && crmIsoReady)) || needSelectCompany) {
    return <PageLoader />;
  }

  return <MainLayout />;
};

export default Main;
